<div class="container-fluid mb-0 mx-1 pb-0 mt-2 movie">
  <div class="row  mb-0">
    <div class="w-100 d-flex justify-content-between">
    <div class="w-100 mr-2 px-0 serch-series-res">
      <div class="form-group has-search mt-3 ml-2">
        <span class="fa fa-search form-control-feedback"></span>
        <input type="text" class="form-control" placeholder="{{ 'COMMON.SEARCH_HERE' | translate }}"
          [(ngModel)]="filterTerm" (keyup)="searchMovies()" (keypress)="preventSpace($event)"  maxlength="120">
        <button type="button" class="btn bg-transparent searchclear" *ngIf="filterTerm" (click)="clearSearch()">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-end mpd">
      <div class=" d-flex-center ">
        <ng-template #popTemplate>
          <div *ngFor="let item of sortButton; let i=index" class="mt-2">
            <button [ngClass]="{'btn-purple': item.selected}"  outsideClick="true" (click)="sortMovie('name',item.val)" type="button"
              class="btn sort-btn btn-dark">
              {{translateFilter(i) | translate }}
            </button>
          </div>
        </ng-template>
        <button type="button" class="btn text-header-backClr header-text border-dark text-white"
          #popover="bs-popover"  triggers="click" outsideClick="true"
          [popover]="popTemplate" placement="left"><i class="fas fa-sort-alt"></i></button>
      </div>
    </div>
    </div>
    <div class="col-12 paddings">
      <div *ngIf="isLoading" class="d-flex-center mt-5">
        <h3>Loading movies...</h3>
        <i class="fas fa-spinner fa-spin ml-2"></i> 
      </div>
    
    <div class="col-12 sm-padding" >
      <div class="row movie-box"  (scroll)="onScroll($event)" #scrollBox>
        
        <div class="col-12" *ngIf="!isLoading && filteredMovie?.length < 1">
          <h3 class="d-flex-center mt-5">{{'COMMON.DATA_NOT_FOUND' | translate}}</h3>
        </div>

        <!-- <div class="col-md-3 col-lg-3 col-xl-2 col-6 px-2 bd-highlight"
          *ngFor="let select of filteredMovie|filter:filterTerm; index as i"> -->
          <div class="col-6 col-sm-4 col-md-4 col-lg-4 col-xl-2 px-2 bd-highlight"
          *ngFor="let select of filteredMovie ; index as i;">
          
          <div class="mb-2 mt-1 tr-effect">
            <div class="">
              <div  type="button" data-toggle="modal" data-target="#exampleModalCenter" data-backdrop="false" [routerLink]="'/movies/watch/' + select.stream_id" target="_self">
                <div class="image-overlay"  (click)="gotoDetail(select.stream_id)">
                  <img [src]="getProxiedImageUrl(select?.stream_icon)" class="search-img movies-img" loading=lazy>
                  <!-- [routerLink]="['/movies/info/'+select.stream_id]" [queryParams]="{movieBy: 'movies',categoryId:categoryId}"> -->

                </div>
              </div>
              <div class="fav-icon icon-color" (click)="onSave(select)"> <i class="far fa-heart  cursor-pointer"
                  *ngIf="!select.is_favorite || !select.isFavourit"></i>
              </div>
              <div class="fav-icon icon-color"> <i class="fas fa-heart  cursor-pointer" *ngIf="select.is_favorite || select.isFavourit"
                  (click)="deleteFavourite(select)"></i>
              </div>
              <div class="d-flex mt-1">
                <p class="search-titles text-left cursor-pointer"  title="{{select.name}}">{{select.name}}</p>
                <a class="ml-auto play-icon" [routerLink]="'/movies/watch/' + select.stream_id" >
                  <!-- <i class="fas fa-play-circle fs-18 text-purple ml-auto cursor-pointer"></i> -->
                <img src="./assets/images/new_icons/movie_play_icon.svg" alt="" [routerLink]="'./movies/watch/' + select.stream_id" >
                </a>
                <!-- <a class="ml-auto" (click)="playvideo(select.stream_id,select.container_extension)"><i
                    class="fas fa-play-circle fs-18 text-purple ml-auto cursor-pointer"></i></a> -->
              </div>
            </div>
          </div>
          </div>
      </div>
    </div>
  </div>
</div>
